// extracted by mini-css-extract-plugin
export default {"side":"Side_side__qierM","side__content":"Side_side__content__nTVJj"};